import { render, staticRenderFns } from "./OptionProductItem.vue?vue&type=template&id=f3ddcac0&scoped=true"
import script from "./OptionProductItem.vue?vue&type=script&lang=js"
export * from "./OptionProductItem.vue?vue&type=script&lang=js"
import style0 from "./OptionProductItem.vue?vue&type=style&index=0&id=f3ddcac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ddcac0",
  null
  
)

export default component.exports